











































































































import Vue, { PropType } from 'vue';
import Button from '@/components/form/Button.vue';
import Preloader from '@/components/preloader/Preloader.vue';
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';
import {
  TCropConfig,
  TCropCoordinate,
  TDictionary,
  TDropDownListWithType,
} from '@/types';
import { getIcon, TIconSvg } from '@/configs/iconsConfigs';
import { getTranslate } from '@/helpers/translateHelpers';
import { getCropAspectRatio, getCropConfig } from '@/configs/creativeConfigs';
import { ICreative } from '@/types/campaign/creatives';
import { splitAspectRatio } from '@/helpers/creativeHelpers';
import NotificationService from '@/services/NotificationService';
import { serializeDataByParams } from '@/helpers/dataHelpers';

export default Vue.extend({
  name: 'CropCreatives',
  components: {
    Button,
    Cropper,
    Preloader,
  },

  props: {
    editedCreative: {
      type: Object as PropType<ICreative>,
      default: null,
    },
  },

  mounted() {
    if (this.editedCreative.coordinates?.length) {
      const coordinates: TDictionary<TCropCoordinate> = serializeDataByParams(
        this.editedCreative.coordinates,
        'aspect_ratio'
      );

      for (const [index, ratio] of this.aspectRatioList.entries()) {
        if (coordinates[ratio.value]) {
          this.refs['cropper-' + index][0].setCoordinates(
            coordinates[ratio.value]
          );
        }
      }
    }
  },

  computed: {
    refs(): any {
      return this.$refs;
    },
    editableCreative(): ICreative {
      return this.editedCreative;
    },
    aspectRatioList(): TDropDownListWithType<string> {
      return getCropAspectRatio();
    },
    cropConfig(): TCropConfig {
      return getCropConfig();
    },
  },

  methods: {
    getIcon(iconName: string): TIconSvg {
      return getIcon(iconName);
    },
    getTranslate(path: string): string {
      return getTranslate(path);
    },
    cropImage() {
      this.cropLoader = true;
      this.editableCreative.coordinates = [];

      try {
        for (const index of this.aspectRatioList.keys()) {
          const { coordinates } = this.refs['cropper-' + index][0].getResult();
          coordinates.aspect_ratio = this.aspectRatioList[index].value;

          this.editableCreative.coordinates?.push(coordinates);
        }
        this.close();
      } catch (err) {
        console.error('cropImage: ', err);
      }

      this.cropLoader = false;
    },
    getAspectRatio(aspectRatio: string): number {
      const [width, height] = splitAspectRatio(aspectRatio);
      return width / height;
    },
    close() {
      this.$emit('close');
    },
    ready(index: number) {
      this.imageLoader[index].loader = false;
      this.imageLoader[index].success = true;
    },
    errors(index: number) {
      this.imageLoader[index].loader = false;
      NotificationService.warning('notifications.failedLoadImage');
    },
  },

  data() {
    return {
      imageLoader: getCropAspectRatio().map(() => ({
        loader: true,
        success: false,
      })),
      cropLoader: false,
    };
  },
});
